import { createRouter, createWebHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';

import { useAuthStore } from '@/stores/auth.store';

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

const PUBLIC_ROUTES = ['/login'];

router.beforeEach((to) => {
  const authStore = useAuthStore();

  if (!authStore.isAuthenticated && !PUBLIC_ROUTES.includes(to.path)) {
    return { path: '/login', query: { redirect: to.fullPath } };
  }

  if (authStore.isAuthenticated && to.path === '/login') {
    return { path: '/' };
  }

  if (authStore.isAuthenticated) {
    const config = authStore.roleConfig;

    if (to.path.startsWith('/settings/users') && !config?.settings.canAccessUserManagement) {
      return { path: '/' };
    }

    if (to.path.startsWith('/settings') && !config?.settings.canAccess) {
      return { path: '/' };
    }

    if (
      to.path.startsWith('/settings') &&
      !to.path.startsWith('/settings/general') &&
      !config?.settings.canAccessSystemSettings
    ) {
      return { path: '/settings/general' };
    }

    if (to.path.startsWith('/projects/import') && !config?.projects.canImport) {
      return { path: '/projects' };
    }

    if (/^\/projects\/[^/]+\/edit$/.exec(to.path) && !config?.projects.canEdit) {
      return { path: to.path.replace(/\/edit$/, '') };
    }

    if (to.path.startsWith('/supervisors') && !config?.sidebar.canAccessSupervisors) {
      return { path: '/' };
    }

    if (to.path.startsWith('/contractors') && !config?.sidebar.canAccessContractors) {
      return { path: '/' };
    }
  }

  return true;
});
